import Api from 'api/index'

const config = {
  baseURL: '/api/app/v1',
}
const api = new Api(config)

api.accountAccessCreate = ({ networkType, accountId, ...rest }) =>
  api.post(`/networks/${networkType}/accounts/${accountId}/accesses`, {
    ...rest,
  })

api.getAccountAccesses = ({ networkType, accountId, ...rest }) =>
  api.get(`/networks/${networkType}/accounts/${accountId}/accesses`, {
    ...rest,
  })

api.deleteAccountAccess = ({ networkType, accountId, accessId }) =>
  api.post(
    `/networks/${networkType}/accounts/${accountId}/accesses/${accessId}/reject`,
  )

export default api
